import { Box, Button, CircularProgress, Typography } from "@mui/material";

// Shown while the logged-in user is being loaded from the API (or if that fails).
const ProfileLoader = ({ failed, onRetry, onLogout }) => (
  <Box
    sx={{
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 2,
    }}
  >
    {failed ? (
      <>
        <Typography>We couldn't load your profile. Please try again.</Typography>
        <Box sx={{ display: "flex", gap: 1 }}>
          <Button variant="contained" onClick={onRetry}>
            Retry
          </Button>
          <Button variant="outlined" onClick={onLogout}>
            Back to login
          </Button>
        </Box>
      </>
    ) : (
      <CircularProgress />
    )}
  </Box>
);

export default ProfileLoader;
